import axios from 'axios';
import Cookies from 'js-cookie';
import { apiAddress } from '../settings'
import { setCookie } from 'nookies'

class AuthAPI {
    //Path for authentication APIs.
    apiURL = apiAddress + '/auth/api';

    setToken(token, context) {
        setCookie(context, 'token', token, {
            maxAge: 3600 * 1000 * 24 * 365 * 10,
            path: '/',
        });
        this.token = token;
    }

    isTokenValid(token) {
        return axios.get(this.apiURL + 'token-check', {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Token ' + token
            },
        }).then(function (response) {
            return response
        }).catch(function (error) {
            return error.response
        });
    }

    login(username, password, rememberme) {
        let headers = {
            'Content-Type': 'multipart/form-data',
        };
        let result;
        //
        let login = new FormData();
        if (rememberme) {
            login.append('rememberme', rememberme);
        }

        return axios.post(
            this.apiURL + '/login/',
            login,
            {
                headers: headers,
                auth: {
                    username: username,
                    password: password,
                },
            }
        ).then((response) => {
            if (response.data.token && response.data.token.length > 0) {
                result = {
                    success: true,
                    token: response.data.token
                }
            } else {
                result = {
                    success: false,
                    error: 'unknown'
                }
            }
            return result
        }).catch(function (error) {
            if (error.response != undefined) {
                if (error.response.status && error.response.status === 401) {
                    result = {
                        success: false,
                        error: 'credential'
                    }
                } else if (error.response.status && error.response.status === 500) {
                    result = {
                        success: false,
                        error: 'server'
                    }
                } else {
                    result = {
                        success: false,
                        error: 'unknown'
                    }
                }
                return result
            }
            result = {
                success: false,
                error: 'unknown'
            }
            return result
        });
    }

    register(password, email, phone) {
        let user = new FormData();
        user.append('phone', phone);
        user.append('password', password);
        user.append('email', email);

        let result = {
            success: false,
            token: null,
            errors: []
        };
        // user.append('country', country);
        // user.append('language', language);
        return axios.post(this.apiURL + '/register/', user)
            .then((response) => {
                result = {
                    success: true,
                    token: response.data.token,
                    errors: []
                }
                return result
            }).catch((error) => {
                if (error.response.status && error.response.status === 400) {
                    if (error.response.data.email) {
                        result = {
                            success: false,
                            token: null,
                            email: true
                        }
                    }
                    if (error.response.data.username) {
                        result = {
                            success: false,
                            token: null,
                            username: true
                        }
                    }
                } else if (error.response.status && error.response.status === 500) {
                    result = {
                        success: false,
                        token: null,
                        server: true
                    }
                } else {
                    result = {
                        success: false,
                        token: null,
                        unknown: true
                    }
                }
                return result
            });
    }

    loginUser(username, password, rememberme) {
        const headers = {
            'Content-Type': 'application/json'
        };



        return axios.post(
            apiAddress + '/landing/api/user/login/',
            {
                'username': username,
                'password': password
            }, // empty body
            { headers }
        )
            .then((response) => {
                if (response.data.token && response.data.token.length > 0) {
                    localStorage.setItem('gh_token', response.data.token);
                    localStorage.setItem('gh_user', response.data.user);
                    return {
                        success: true,
                        token: response.data.token
                    };
                }
                return { success: false, error: 'unknown' };
            })
            .catch((error) => {
                if (error.response) {
                    if (error.response.status === 401) {
                        return { success: false, error: 'credential' };
                    } else if (error.response.status === 500) {
                        return { success: false, error: 'server' };
                    }
                    return { success: false, error: 'unknown' };
                } else {
                    // Network error (CORS, server down, mixed content, etc.)
                    return { success: false, error: 'network' };
                }
            });
    }

    registerNew(email, password, rePassword) {
        const headers = {
            'Content-Type': 'application/json'//,
            //'Authorization': 'Basic ' + btoa(username + ':' + password)
        };
        return axios.post(
            apiAddress + '/accounts/api/register/',
            JSON.stringify({ email: email, password: password, re_password: rePassword }), // body
            { headers }
        )
            .then((response) => {
                if (response.data.detail && response.data.detail.length > 0) {
                    if (response.data.detail == 'User created') {
                        return {
                            success: true
                        };
                    }

                }
                return { success: false, error: 'unknown' };
            })
            .catch((error) => {
                if (error.response) {
                    if (error.response.status === 401) {
                        return { success: false, error: 'credential' };
                    } else if (error.response.status === 500) {
                        return { success: false, error: 'server' };
                    }
                    return { success: false, error: 'unknown' };
                } else {
                    return { success: false, error: 'network' };
                }
            });
    }

    logoutUser() {
        const token = localStorage.getItem('gh_token');
        if (!token) return { success: false, error: 'unknown' };

        const headers = {
            'Content-Type': 'application/json',
            'Authorization': 'Token ' + token
        };

        localStorage.removeItem('gh_token');
        //this.setState({ loggedIn: false, username: null });

        return axios.post(
            apiAddress + '/accounts/api/logout/',
            {}, // empty body
            { headers }
        )
            .then((response) => {
                if (response.status == 204) {
                    return {
                        success: true,
                        token: response.data.token
                    };
                }
                return { success: false, error: 'unknown' };
            })
            .catch((error) => {
                if (error.response) {
                    if (error.response.status === 401) {
                        return { success: false, error: 'credential' };
                    } else if (error.response.status === 500) {
                        return { success: false, error: 'server' };
                    }
                    return { success: false, error: 'unknown' };
                } else {
                    // Network error (CORS, server down, mixed content, etc.)
                    return { success: false, error: 'network' };
                }
            });


    }

    checkUserLogin() {
        const token = localStorage.getItem('gh_token');
        //if (!token) return { success: false, error: 'unknown' };

        const headers = {
            'Content-Type': 'application/json',
            'Authorization': 'Token ' + token
        };

        return axios.get(
            apiAddress + '/accounts/api/me/',
            { headers }
        )
            .then((response) => {
                if (response.status == 200) {
                    localStorage.setItem('gh_user', response.data);
                    return {
                        success: true,
                        user: response.data
                    };
                }
                return { success: false, error: 'unknown' };
            })
            .catch((error) => {
                if (error.response) {
                    if (error.response.status === 401) {
                        localStorage.removeItem('gh_token');
                        return { success: false, error: 'credential' };
                    } else if (error.response.status === 500) {
                        return { success: false, error: 'server' };
                    }
                    return { success: false, error: 'unknown' };
                } else {
                    // Network error (CORS, server down, mixed content, etc.)
                    return { success: false, error: 'network' };
                }
            });
    }

    UpdateProfile(firstName, lastName, phoneNumber) {
        const token = localStorage.getItem('gh_token');
        //if (!token) return { success: false, error: 'unknown' };

        const headers = {
            'Content-Type': 'application/json',
            'Authorization': 'Token ' + token
        };

        return axios.patch(
            apiAddress + '/accounts/api/profile/',
            JSON.stringify({ firstName: firstName, lastName: lastName, phoneNumber: phoneNumber }),
            { headers }
        )
            .then((response) => {
                if (response.status == 200) {
                    localStorage.setItem('gh_user', response.data.user);
                    return {
                        success: true,
                        user: response.data
                    };
                }
                return { success: false, error: 'unknown' };
            })
            .catch((error) => {
                if (error.response) {
                    if (error.response.status === 400) {
                        return { success: false, error: error.response.data.detail };
                    }
                    return { success: false, error: 'unknown' };
                } else {
                    // Network error (CORS, server down, mixed content, etc.)
                    return { success: false, error: 'network' };
                }
            });
    }

    sendCarpet(data, background, comment, location) {
        const token = localStorage.getItem('gh_token');
        //if (!token) return { success: false, error: 'unknown' };

        const headers = {
            'Content-Type': 'application/json',
            'Authorization': 'Token ' + token
        };

        return axios.post(
            apiAddress + '/accounts/api/save_carpet/',
            JSON.stringify({
                data: data,
                background_image: background,
                comment: comment,
                location: location,
            }),
            { headers }
        )
            .then((response) => {
                if (response.status == 200) {
                    return {success: true};
                }
                return { success: false, error: 'unknown' };
            })
            .catch((error) => {
                if (error.response) {
                    if (error.response.status === 400) {
                        return { success: false, error: error.response.data.detail };
                    }
                    return { success: false, error: 'unknown' };
                } else {
                    // Network error (CORS, server down, mixed content, etc.)
                    return { success: false, error: 'network' };
                }
            });
    }
}

export default AuthAPI;
